import React, {
  useMemo,
  useState,
  useContext,
  useEffect,
  useCallback,
  useRef,
} from "react";
import { useForm } from "react-hook-form";
import { useHistory } from "react-router";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import classnames from "classnames";
import GoogleAutoComplete from "../common/GoogleAutoComplete";
import { AppContexts } from "../../providers";
import UIkit from "uikit";

const schema = yup.object().shape({
  pms_id: yup.string().required(),
});

const AddScenario = () => {
  const [placeId, setPlaceId] = useState(null);
  const DestinationContext = useContext(AppContexts.DestinationContext);
  const UtilContext = useContext(AppContexts.UtilContext);
  const { user } = useContext(AppContexts.AuthContext);
  const RentalsContext = useContext(AppContexts.RentalsContext);
  const [isValidate, setValidate] = useState(true);
  const [autoCompleteValue, setAutoCompleteValue] = useState("");
  const history = useHistory();
  const offcanvasRef = useRef(null);
  const {
    register,
    setValue,
    getValues,
    handleSubmit,
    watch,
    setError,
    clearErrors,
    reset,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
  });

  const handleRegister = async (data) => {
    placeId ? setValidate(true) : setValidate(false);
    if (placeId) {
      try {
        let rental = {};
        if (RentalsContext.isNew) {
          RentalsContext.setUpsertLoading(true);
          let place = await UtilContext.place(placeId);
          rental = {
            destination_id: 0,
            google_place_id: place.place_id,
            host_id: user.account_id,
            pms_id: data.pms_id || "",
            name: data.name || place.name,
            address: place.formatted_address,
            lat: data.lat || place.geometry.location.lat,
            lng: data.lng || place.geometry.location.lng,
            property_code: "",
          };
          rental = await RentalsContext.createRental(rental);
        } else {
          rental = {
            destination_id: 0,
            host_id: user.account_id,
            pms_id: data.pms_id || "",
            name: data.name,
            property_code: "",
          }
          if (placeId !== RentalsContext.rental.google_place_id) {
            RentalsContext.setUpsertLoading(true);
            let place = await UtilContext.place(placeId);
            rental = {
              destination_id: data.destination_id == "" ? 0 : data.destination_id,
              google_place_id: place.place_id,
              host_id: user.account_id,
              pms_id: data.pms_id || "",
              name: data.name || place.name,
              address: place.formatted_address,
              lat: data.lat || place.geometry.location.lat,
              lng: data.lng || place.geometry.location.lng,
              property_code: "",
            };
          }
          rental = await RentalsContext.updateRental(
            RentalsContext.rental.rental_id,
            {
              ...RentalsContext.rental,
              ...rental,
            }
          );
        }
  
        if (!rental) {
          UIkit.notification("Failed", "error");
          RentalsContext.setUpsertLoading(false);
        } else {
          UIkit.modal("#addPropertyGuide-modal").hide();
          UIkit.notification(
            RentalsContext.isNew ? "Added Successfully" : "Updated Successfully",
            "success"
          );
          RentalsContext.setUpsertLoading(false);
  
          RentalsContext.get();
          if (RentalsContext.isNew)
            history.push(`/support-hub`);
          RentalsContext.setIsNew(false);
        }
      } catch (err) {
        RentalsContext.setUpsertLoading(false);
        console.log(err);
      }
    }
  };

  const handleBeforeHide = (e) => {
    if (e.target === offcanvasRef.current) {
      setAutoCompleteValue("");
      setValidate(true);
      reset();
      clearErrors();
      RentalsContext.setRental({});
    }
  };

  useEffect(() => {
    const offcanvasElement = UIkit.offcanvas(offcanvasRef.current);
    const offcanvasDOMElement = offcanvasElement.$el;
    offcanvasDOMElement.addEventListener("beforehide", handleBeforeHide);
    return () => {
      offcanvasDOMElement.removeEventListener("beforehide", handleBeforeHide);
    };
  }, []);

  useEffect(() => {
    if (RentalsContext.isNew) {
      reset();
      setAutoCompleteValue("");
    } else {
      setValue("pms_id", RentalsContext.rental.pms_id);
      setValue("name", RentalsContext.rental.name);
      setValue("destination_id", RentalsContext.rental.destination_id);
      setPlaceId(RentalsContext.rental.google_place_id);
      setAutoCompleteValue(RentalsContext.rental.address);
      setValue('lat', RentalsContext.rental.lat);
      setValue('lng', RentalsContext.rental.lng);
    }
  }, [RentalsContext.isNew, RentalsContext.rental]);

  useEffect(() => {
    if (RentalsContext.error)
      setError("pms_id", { type: "custom", message: RentalsContext.error });
  }, [RentalsContext.error]);

  useEffect(() => {
    RentalsContext.setPMSError(null);
  }, [watch("pms_id")]);

  const destination_id = useMemo(
    () => getValues("destination_id"),
    [watch("destination_id")]
  );

  const handleError = (err) => {
    console.log(err);
  };

  return (
    <div
      id="addPropertyGuide-modal"
      className="uk-modal-full hms-modals uk-modal"
      uk-offcanvas="overlay: true; flip: true;"
      ref={offcanvasRef}
    >
      <div className="uk-offcanvas-bar">
        <div className="hms-modals-main">
          <button
            className="uk-offcanvas-close uk-close-large"
            type="button"
            uk-close="true"
          ></button>
          <div className="uk-modal-header">
            <h2 className="uk-modal-title">
              {RentalsContext.isNew ? "Add a" : "Edit"} Scenario
            </h2>
          </div>
          <div className="uk-modal-body">
            <form
              className="uk-grid-small"
              uk-grid="true"
              onSubmit={handleSubmit(handleRegister, handleError)}
            >
              <div className="uk-width-1-1">
                <div className="uk-form-controls">
                  <label className="uk-form-label">Category</label>
                  <div className="uk-form-controls">
                    <div uk-form-custom="target: > * > span:first-child">
                      <select {...register("category")}>
                        <option value="">Select a Category</option>
                          <option value="access">Access / Lockout</option>
                          <option value="air">Air Conditioner</option>
                          <option value="heat">Heat / Furnace</option>
                          <option value="water">No Water</option>
                          <option value="power">Power Outage</option>
                          <option value="internet">WiFi / Internet</option>
                          <option value="tv">TV / Streaming Issues</option>
                          <option value="noise">Noise Complaint</option>
                          <option value="cleaning">Cleaning Issue</option>
                          <option value="pest">Pest / Insects</option>
                          <option value="plumbing">Plumbing / Toilet / Drain</option>
                          <option value="appliance">Appliance Not Working</option>
                          <option value="hot_tub">Hot Tub / Pool Issue</option>
                          <option value="alarm">Smoke Alarm / Security Alarm</option>
                          <option value="parking">Parking Issue</option>
                          <option value="safety">Safety Concern</option>
                          <option value="other">Other</option>
                      </select>
                      <button
                        className="uk-button uk-button-default"
                        type="button"
                        tabIndex="-1"
                      >
                        <span className="select-value">
                          {getValues("category")}
                        </span>
                        <span
                          uk-icon="icon: chevron-down"
                          className="hms-align-right"
                        ></span>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div className="uk-width-1-1">
                <div className="uk-form-controls">
                  <label className="uk-form-label">Scenario Name</label>
                  <input
                    className={classnames("uk-input", {
                      error: errors["pms_id"],
                    })}
                    type="text"
                    {...register("pms_id")}
                  />
                  <div className="uk-label-danger">
                    {RentalsContext.error}
                  </div>
                </div>
              </div>
              <div className="uk-width-1-1">
                <div className="uk-form-controls">
                  <label className="uk-form-label">Description</label>
                  <input
                    className={classnames("uk-input", {
                      error: errors["pms_id"],
                    })}
                    type="text"
                    {...register("pms_id")}
                  />
                  <div className="uk-label-danger">
                    {RentalsContext.error}
                  </div>
                </div>
              </div>
              <div className="uk-width-1-1">
                <div className="uk-form-controls">
                  <label className="uk-form-label">Action Steps</label>
                  <textarea
                    className="uk-textarea"
                    rows="5"
                    {...register("action_steps")}
                  ></textarea>
                  <div className="uk-label-danger">
                    {RentalsContext.error}
                  </div>
                </div>
              </div>
              <div className="uk-width-1-1">
                <div className="uk-flex uk-flex-middle">
                  <div className="autosend-checkbox">
                    <label for="useWebChat" className="setting-switch">
                      <input
                        type="checkbox"
                        id="useWebChat"
                      />
                      <span className="setting-slider setting-round"></span>
                    </label>
                  </div>
                  <div className="uk-form-label uk-margin-small-left">Escalation Required</div>
                </div>
              </div>
              <div className="uk-width-1-1">
                <div className="uk-form-controls">
                  <label className="uk-form-label">Escalation Steps</label>
                  <textarea
                    className="uk-textarea"
                    rows="5"
                    {...register("escalation_steps")}
                  ></textarea>
                </div>
              </div>                            
              <div className="uk-width-1-1">
                <div className="uk-flex uk-flex-middle">
                  <div className="autosend-checkbox">
                    <label for="useWebChat" className="setting-switch">
                      <input
                        type="checkbox"
                        id="useWebChat"
                      />
                      <span className="setting-slider setting-round"></span>
                    </label>
                  </div>
                  <div className="uk-form-label uk-margin-small-left">Active</div>
                </div>
              </div>
              <div>
                <button
                  className="uk-button hms-btn hms-red-btn"
                  type="submit"
                  disabled={RentalsContext.upsertLoading}
                >
                  {RentalsContext.upsertLoading ? (
                    <div data-uk-spinner="ratio: 0.5;">Saving </div>
                  ) : (
                    "Save"
                  )}
                </button>
                <button
                  className="uk-button hms-btn uk-offcanvas-close"
                  type="button"
                >
                  Cancel
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddScenario;
